var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',[(_vm.loading)?_c('div',{staticClass:"overlay-loading",style:(_vm.style)},[_c('v-progress-circular',{attrs:{"size":50,"width":5,"color":"accent","indeterminate":""}}),_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }